/* ============
 * Locale
 * ============
 *
 * For a multi-language application, you can
 * specify the languages you want to use here.
 */

import en from "./en-US";
import es from "./es-MX";
import hi from "./hi-IN";

export default {
  en,
  es,
  hi
};